import PropTypes from 'prop-types';
import React from 'react';

class LoginEdit extends React.Component {
  static get propTypes() {
    return {};
  }

  render() {
    return (
      <>
        <form method="post" action="http://localhost:8080/login/dummy">
          <button type={'submit'}>成功ログイン</button>
        </form>
        <form method="post" action="http://localhost:8080/login/dummy_failure">
          <button type={'submit'}>失敗ログイン</button>
        </form>
      </>
    );
  }
}

export default LoginEdit;
